// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.emd-copy[data-v-47fd1578] {\n  gap: 4px;\n}\n", ""]);
// Exports
module.exports = exports;
